module.exports = __webpack_public_path__ + "static/media/Group-17.b8a52808.png";